import { Injectable } from '@angular/core';
import { ConfigService } from '../config.service';
import { HttpExtendedService } from '../http-extended.service';
import { Subject } from 'rxjs';
import { User } from 'src/models/user';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl: string;
  private localStorageKey = 'currentUser';
  adminLoggedCast: Subject<boolean> = new Subject<boolean>();

  constructor(
    private http: HttpExtendedService,
    config: ConfigService,
    private toast: ToastrService
  ) {
    this.apiUrl = config.config.userUrl;
  }

  login(logInfo: User) {
    this.http.post<User>(this.apiUrl + '/login', logInfo)
      .subscribe(user => {
        if (user) {
          localStorage.setItem(this.localStorageKey, JSON.stringify(user));
          this.toast.success('Admin logged!');
        }
        this.isAdminLogged();
      });
  }

  isAdminLogged(): void {
    if (localStorage.getItem(this.localStorageKey) === null) {
      this.adminLoggedCast.next(false);
      return;
    }
    const isLogged = JSON.parse(localStorage.getItem(this.localStorageKey)).isAdmin;
    this.adminLoggedCast.next(isLogged);
  }

  logout() {
    localStorage.removeItem(this.localStorageKey);
    this.adminLoggedCast.next(false);
    this.toast.warning('Admin logout!');
  }
}
